import { useCallback, useEffect, useMemo } from "react";
import { ChipItem } from "@/common/components/ChipsContainer/Props";
import { FILTER_ITEMS_LIMIT as limit } from "@/config";
import JobsCompanyFilterProps from "./JobsCompanyFilter.types";
import { useJobsCompaniesQuery } from "@/common/components/Filter/components/JobsCompanyFilter/JobsCompanyFilter.operations.generated";

export function useJobsCompanyFilter(props: JobsCompanyFilterProps) {
  const { applyFilter, filter, clearFilter } = props.context;
  const {
    data: companiesData,
    fetchMore,
    refetch: refetchCompanies,
  } = useJobsCompaniesQuery({
    fetchPolicy: "cache-and-network",
    variables: {
      offset: 0,
      limit,
      query: "",
    },
  });

  const companiesTotalCount = companiesData?.jobsCompanies.count || 0;

  const allCompanies = useMemo(
    () => companiesData?.jobsCompanies.entities || [],
    [companiesData?.jobsCompanies.entities]
  );

  const activeCompanies = filter.company;

  const refetchWithQuery = useCallback(
    (query: string) => {
      refetchCompanies({ offset: 0, limit, query });
    },
    [refetchCompanies]
  );

  const handleChangeCompanyFilter = useCallback(
    (company: ChipItem) => {
      applyFilter("company", company);
    },
    [applyFilter]
  );

  const handleClear = useCallback(() => {
    clearFilter("company");
  }, [clearFilter]);

  useEffect(() => {
    refetchWithQuery("");
  }, [refetchWithQuery]);

  const loadMore = useCallback(
    (query: string) => {
      fetchMore({
        variables: {
          offset: allCompanies.length,
          limit,
          query,
        },
      });
    },
    [allCompanies.length, fetchMore]
  );

  return {
    allCompanies,
    activeCompanies,
    handleChangeCompanyFilter,
    handleClear,
    clearDisabled: !activeCompanies.length,
    loadMore,
    companiesTotalCount,
    handleQueryChange: refetchWithQuery,
  };
}
